import { billingRoutesConfig } from 'domains/account/routes';
import { pricingRoutesConfig } from 'domains/pricing/routes';

export const BILLING_TAB_INDEX = 0 as const;
export const USAGE_TAB_INDEX = 1 as const;
export const PLANS_TAB_INDEX = 2 as const;

const billingPage = billingRoutesConfig.billing.generatePath();
const usagePage = billingRoutesConfig.usage.generatePath();
const pricingPage = pricingRoutesConfig.pricing.generatePath();

export const INDEX_TO_PATH_MAP = {
  [BILLING_TAB_INDEX]: billingPage,
  [USAGE_TAB_INDEX]: usagePage,
  [PLANS_TAB_INDEX]: pricingPage,
};

export const PATH_TO_INDEX_MAP = {
  [billingPage]: BILLING_TAB_INDEX,
  [usagePage]: USAGE_TAB_INDEX,
  [pricingPage]: PLANS_TAB_INDEX,
};
